/** Sections 4–5: Terms of Service (SP only), Prohibited Uses. Exact legal text from prototype. */

export const Sections4To5 = () => (
  <>
    <li data-list-text={4}>
      <h1 style={{ paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
        Terms of Service (applicable to Service Providers only)
      </h1>
      <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
      <p style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}>
        This Section 4 applies only to Service Providers that have entered into a Membership Agreement with bQuest (a "Membership"). By purchasing, using, or availing yourself of bQuest Platform Membership, you agree to the following terms and conditions.
      </p>
      <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
      <p style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}>
        bQuest may immediately terminate or suspend your account, and all or a portion of your Membership, without notice if:
      </p>
      <ol id="l3">
        <li data-list-text={1}>
          <p style={{ paddingTop: '13pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            your payment is overdue (provided that we will use reasonable efforts to notify you of the overdue payment before we terminate or suspend);
          </p>
        </li>
        <li data-list-text={2}>
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            you provide false or inaccurate information;
          </p>
        </li>
        <li data-list-text={3}>
          <p style={{ paddingTop: '12pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            you violate these Terms of Service or any other bQuest rules or agreements then in effect;
          </p>
        </li>
        <li data-list-text={4}>
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            you engage in conduct that is a violation of any applicable law or tariff (including, without limitation, copyright and intellectual property laws); or
          </p>
        </li>
        <li data-list-text={5}>
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            if you engage in conduct that is threatening, abusive or harassing to Users, Service Providers, bQuest employees, agents, or other bQuest' users, including, for example, making threats to physically harm or damage property.
          </p>
        </li>
      </ol>
      <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
      <p style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}>
        In the event that bQuest determines, in its sole discretion, that your Membership is being accessed in a commercial setting or is for commercial use, bQuest reserves the right terminate or suspend
      </p>
      <p style={{ paddingTop: '3pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}>
        your Membership at any time without notice. You understand and agree that conversion of a Membership to a commercial subscription may be subject to additional fees and requirements as provided to you by bQuest.
      </p>
      <p style={{ paddingTop: '13pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}>
        If we terminate or suspend your Membership, your license to use any software or content provided in connection with the Membership is also terminated or suspended (as applicable). If your Membership is terminated, bQuest has the right to immediately delete all data, files, and other information stored in or for your account without further notice to you. You must pay all charges up to and including the date of termination. Should you wish to resume your Membership after any suspension, a restoration of service fee may apply. This fee is in addition to all past due unpaid charges and other fees.
      </p>
      <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
    </li>
    <li data-list-text={5}>
      <h1 style={{ paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
        Prohibited Uses; Reporting Abuse
      </h1>
      <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
      <p style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}>
        Without limitation, while using the bQuest Platform, Users may not:
      </p>
      <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
      <ul id="l4">
        <li data-list-text="●">
          <p style={{ paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            You should NOT use the bQuest Platform to share confidential or sensitive information of any kind.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            Publish, post, upload, distribute or disseminate any image, name, material or information regarding any other person, without the express permission of such person.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            Defame, abuse, harass, stalk, threaten or otherwise violate the legal rights (such as, but not limited to, rights of privacy and publicity) of others, including Users, Service Providers and bQuest staff.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            Publish, post, upload, distribute or disseminate any profane, defamatory, infringing, obscene or unlawful topic, name, material or information.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            Use the bQuest Platform for any purpose in violation of local, state, national, or international law.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            Upload files that contain software or other material that violates the intellectual property rights (or rights of privacy or publicity) of any third party.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            Engage in social engineering or upload files that contain viruses, Trojan horses, corrupted files, or any other similar software that may damage the operation of another's computer.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            Post or upload any content to which you have not obtained any necessary rights or permissions to use accordingly.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '12pt', paddingLeft: '40pt', textIndent: '-17pt', textAlign: 'left' }}>
            Advertise or offer to sell any goods or services for any commercial purpose.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '40pt', textIndent: '-17pt', textAlign: 'left' }}>
            Conduct or forward surveys, contests, pyramid schemes, or chain letters.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            Provide false or inaccurate information when registering an account on the bQuest Platform, using the Services or communicating with other Users or Service Providers.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '3pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            Impersonate another person or a User or Service Provider or allow any other person or entity to use your identification to post or view comments.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            Download any file posted by another User or Service Provider that a User or Service Provider knows, or reasonably should know, cannot be legally distributed through the bQuest Platform.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            Restrict or inhibit any other User or Service Provider from using and enjoying the Public Areas.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            Imply or state that any statements you make are endorsed by bQuest, without the prior written consent of bQuest.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            Use a robot, spider, manual and/or automatic processes or devices to data-mine, data-crawl, scrape or index the bQuest Platform in any manner.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '40pt', textIndent: '-17pt', textAlign: 'left' }}>
            Hack or interfere with the bQuest Platform, its servers or any connected networks.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            Adapt, alter, license, sublicense or translate the bQuest Platform for your own personal or commercial use.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            Remove or alter, visually or otherwise, any copyrights, trademarks or proprietary marks and rights owned by bQuest.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            Upload content that is offensive and/or harmful, including, but not limited to, content that advocates, endorses, condones or promotes racism, bigotry, hatred or physical harm of any kind against any individual or group of individuals.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            Use the bQuest Platform to solicit for any other business, website or service, or otherwise contact Users or Service Providers for employment, contracting or any purpose not related to use of the bQuest Platform as set forth herein.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'left' }}>
            Use the bQuest Platform to collect usernames and or/email addresses of Users or Service Providers by electronic or other means.
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            Register under different usernames or identities, after your account has been suspended or terminated, or terminate your registration and re-register in order to prevent a review from being associated with your account.
          </p>
        </li>
        <li data-list-text="●">
          <p className="s4" style={{ paddingTop: '11pt', paddingLeft: '40pt', textIndent: '-17pt', textAlign: 'left' }}>
            Reporting Abuse
          </p>
        </li>
        <li data-list-text="●">
          <p style={{ paddingTop: '11pt', paddingLeft: '41pt', textIndent: '-18pt', textAlign: 'justify' }}>
            BY USING THE SITE OR THE SERVICES, YOU AGREE TO REPORT ANY ALLEGED IMPROPRIETIES OF ANY USERS TO BQUEST IMMEDIATELY VIA ELECTRONIC CORRESPONDENCE. IN THE EVENT THAT ANY ALLEGATION OF IMPROPER CONDUCT BY ANY USER IN VIOLATION OF THESE TERMS OR OF APPLICABLE LAW, BQUEST WILL IMMEDIATELY SUSPEND THE ACCOUNT OF SUCH USER PENDING A FULL INVESTIGATION INTO SUCH ALLEGATIONS.
          </p>
        </li>
      </ul>
    </li>
  </>
);
